import { contactRequest } from '@frontend/contact';
import { useEffect, useState } from 'react';

import { useAppSelector } from '../../redux/store';
import { ContactBadgeProps } from './contact-badge.component';

interface ViewProps {
    displayName?: { first_name?: string; last_name?: string } | string;
    disabled: boolean;
}

const useContactBadge = (props: ContactBadgeProps): ViewProps => {
    const [requested, changeRequested] = useState<boolean>(false);
    const contactState = useAppSelector((state) => state.contacts);
    const [displayName, changeDisplayName] = useState<{ first_name?: string; last_name?: string } | undefined | string>({
        first_name: props.first_name,
        last_name: props.last_name
    });
    const [disabled, changeDisabled] = useState<boolean>(false);
    useEffect(() => {
        if (props.id != undefined) {
            const found = contactState.unordered.find((c) => c.id == props.id);
            if (found) {
                changeDisplayName({ first_name: found.first_name, last_name: found.last_name });
            } else if (requested == false) {
                changeRequested(true);
                contactRequest(props.id);
            }

            if (requested && !found) {
                changeDisabled(true);
                changeDisplayName('Not found');
            }
        }
    }, [contactState, props.id]);
    return { displayName, disabled };
};

export default useContactBadge;
